import { render, staticRenderFns } from "./SegmentsPopup.vue?vue&type=template&id=48c31434"
import script from "./SegmentsPopup.vue?vue&type=script&lang=js"
export * from "./SegmentsPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports